import ModalTypes from "./modals.types";

const INITIAL_STATE = {
    representationModal: false,
    faqQuestion: false,
    firstPin: true
};

const ModalReducer = (state = INITIAL_STATE, action)=>{
    switch (action.type) {
        case ModalTypes.TOGGLE_REPRESENTATION_MODAL :
            return{
                ...state,
                representationModal: !state.representationModal
            };
        case ModalTypes.TOGGLE_FAQ_QUESTION :
            return{
                ...state,
                faqQuestion: !state.faqQuestion
            };
        case ModalTypes.TOGGLE_FIRST_PIN :
            return{
                ...state,
                firstPin: !state.firstPin
            };
        default :
            return state
    }
};

export default ModalReducer